import React from "react";

import PageHeading from "2g-page-heading";

import ProvozniInformaceCards from "b2b/components/provozni-informace-cards";

const data = require("b2b-devel/provozni-informace/seznam.json");

export function ProvozniInformaceCardsExample() {
  return (
    <>
      <PageHeading>ProvozniInformaceCards</PageHeading>
      <div data-testid="ProvozniInformaceCards">
        <ProvozniInformaceCards items={data} />
      </div>
      <PageHeading>ProvozniInformaceCards - loading</PageHeading>
      <div data-testid="ProvozniInformaceCards.is-loading">
        <ProvozniInformaceCards loading />
      </div>
      <PageHeading>ProvozniInformaceCards - empty</PageHeading>
      <div data-testid="ProvozniInformaceCards.is-empty">
        <ProvozniInformaceCards items={[]} />
      </div>
    </>
  );
}

ProvozniInformaceCardsExample.propTypes = {};

export default React.memo(ProvozniInformaceCardsExample);
